import { useState } from "react";

function MiniShopsPage({ error, isSaving, onCreate, onEdit, shops }) {
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ shop_name: "", description: "", owner_type: "private" });

  async function submit(event) {
    event.preventDefault();
    const created = await onCreate(form);
    if (created) {
      setForm({ shop_name: "", description: "", owner_type: "private" });
      setShowForm(false);
    }
  }

  return <section className="main-panel mini-shops-page">
    <div className="section-toolbar">
      <div><span className="mini-label">Dine butikker</span><h1>Mine shops</h1><p>Opret og rediger dine private eller professionelle shops.</p></div>
      <button className="primary-action" onClick={() => setShowForm((value) => !value)} type="button">Opret mini shop</button>
    </div>
    {error && <p className="error-message">{error}</p>}
    {showForm && <form className="shop-settings mini-shop-create" onSubmit={submit}>
      <div className="shop-owner-type">
        <label><input checked={form.owner_type === "private"} name="ownerType" onChange={() => setForm({ ...form, owner_type: "private" })} type="radio" /> Privat</label>
        <label><input checked={form.owner_type === "business"} name="ownerType" onChange={() => setForm({ ...form, owner_type: "business" })} type="radio" /> Virksomhed</label>
      </div>
      <label>Shopnavn<input maxLength="120" required value={form.shop_name} onChange={(event) => setForm({ ...form, shop_name: event.target.value })} /></label>
      <label>Beskrivelse<textarea maxLength="300" value={form.description} onChange={(event) => setForm({ ...form, description: event.target.value })} /></label>
      <button className="primary-action" disabled={isSaving} type="submit">{isSaving ? "Opretter..." : "Opret shop"}</button>
    </form>}
    <div className="mini-shop-grid">
      {shops.map((shop) => <article className="mini-shop-card" key={shop.id}>
        <div className="shop-logo-placeholder">{shop.shop_name.slice(0, 2).toUpperCase()}</div>
        <div><strong>{shop.shop_name}</strong><span>{shop.owner_type === "business" ? "Virksomhed" : "Privat butik"}</span></div>
        <button className="secondary-action" onClick={() => onEdit(shop)} type="button">Rediger</button>
      </article>)}
      {!shops.length && !showForm && <div className="empty-results">Du har ingen mini shops endnu.</div>}
    </div>
  </section>;
}

export default MiniShopsPage;
